export const LOGIN_HERO_FEATURES = [
  { icon: "🔗", key: "Auto-generate REST endpoints for any Odoo model" },
  { icon: "⚡", key: "Token-based authentication with usage tracking" },
  { icon: "🔒", key: "Enterprise security — your data never leaves Odoo" },
  { icon: "📊", key: "Full CRUD — View, Create, Update, Delete records" }
];

export const REGISTER_HERO_FEATURES = [
  { icon: "🆓", key: "Auto-generate REST endpoints for any Odoo model" },
  { icon: "🚀", key: "Token-based authentication with usage tracking" },
  { icon: "🔄", key: "Enterprise security — your data never leaves Odoo" },
  { icon: "📦", key: "Full CRUD — View, Create, Update, Delete records" }
];

export const LOGIN_HERO_ORBS = {
  blue: { top: "-60px", right: "-40px" },
  purple: { bottom: "40px", left: "-30px" }
};

export const REGISTER_HERO_ORBS = {
  blue: { top: "20px", right: "-20px" },
  purple: { bottom: "80px", left: "0" }
};

export const REGISTER_HERO_SUBTITLE_KEY =
  "Generate, manage, and deploy enterprise-grade Odoo REST APIs in minutes.";
